export const FilterTypeId = {
  Dropdown: 1,
  Switch: 2,
  SelectDropDown: 3
};
